<template>
  <div class="componentsCtn_1">
    <div class="top">
      <span v-if="exhibitLevel==1">我的项目</span>
      <span v-if="exhibitLevel==2">
          <span @click="exhibitLevel=1" style="color:rgba(0,0,0,0.6);cursor:pointer;">我的项目/</span>
          <span>{{currentProject.name}}</span>
        </span>
    </div>
    <!--我的项目一级页面-->
    <div v-if="exhibitLevel==1" class="signUp_content">
      <div class="componentCtn-main">
        <div class="projectCtn">
          <div class="topCtn"
               title="创建项目"
               @click="createProjectModal=true;showVectoryCheckLoading=false;CascaderSelectId++"
               style="background: #D8D8D8;border:none;display: flex;justify-content: center;align-items: center">
            <img src="../../assets/userCenter/我的项目-增加按钮.png"  height="93" width="93"/>
          </div>
          <div class="middleCtn">
          </div>
          <div class="bottomCtn">
          </div>
        </div>
        <div v-for="item in projectList" :key="item.id" class="projectCtn">
          <div class="topCtn">
            <div class="contentMask">

              <div class="contentItem">
                项目状态:<span v-if="item.delete_status==0&&item.end_time>getTodayTime()&&item.start_time<getTodayTime()">进行中</span><span
                  v-if="item.delete_status==1" style="color:red;">已终止</span><span v-if="item.delete_status==0&&item.end_time<getTodayTime()" style="color:red;">已过期</span><span v-if="item.delete_status==0&&item.start_time>getTodayTime()" style="color:red;">尚未到期</span>
              </div>
              <div class="contentItem">
                有效期:{{ item.start_time.split(" ")[0] }}-{{ item.end_time.split(" ")[0] }}
              </div>
              <div class="contentItem" style="text-align: center;height:auto;margin-top: 20px;">
                <!--仅创建者和队长可以进入团队-->
                <span v-if="item.group_created_user_id==item.member_user_id||item.role=='1'">
                   <a-button  @click="clickProject(item.id,item)" type="primary" style="font-size: 12px" :disabled="item.delete_status!=0">进入项目</a-button>
                </span>
                <span v-else>
                  <a-button  @click="$message.error('仅创建者或队长可以进入')" type="primary" style="font-size: 12px" :disabled="item.delete_status!=0">进入项目</a-button>
                </span>
              </div>
            </div>
            <!--标识-->
            <a-tag v-if="item.group_created_user_id==item.member_user_id" style="position:absolute;top:9px;right: 3px;" color="green">
              创建者
            </a-tag>
            <!--标识-->
            <a-tag v-else-if="item.role=='1'" style="position:absolute;top:9px;right: 3px;" color="blue">
             队长
            </a-tag>
            <!--标识-->
            <a-tag v-else style="position:absolute;top:9px;right: 3px;" color="gray">
              普通队员
            </a-tag>
          </div>
          <div :title="item.name" class="middleCtn">
            {{ item.name }}
          </div>
          <div class="bottomCtn" v-if="item.delete_status==0&&item.group_created_user_id==item.member_user_id">
            <img @click="clickEditProject(item)" title="编辑" class="bottomImg" src="../../assets/userCenter/我的项目-详情.png"
                 height="18" width="18"/>
            <img @click="clickShareProject(item)" title="分享" class="bottomImg" src="../../assets/userCenter/我的项目-分享.png"
                 height="18" width="18"/>
            <img @click="clickCloseProject(item)" title="关闭"
                 class="bottomImg" style="margin-right: 0px;" src="../../assets/userCenter/我的项目-退出.png"
                 height="18" width="18"/>
          </div>
          <div class="bottomCtn" v-else-if="item.delete_status==1">
            <div
                style="width: 100%;height:30px;padding-left:5px;line-height: 30px;text-align: center;color:#adadad;font-weight: bold">
              --已关闭--
            </div>
          </div>
          <div class="bottomCtn" v-else>
            <div
                style="width: 100%;height:30px;padding-left:5px;line-height: 30px;text-align: center;color:#adadad;font-weight: bold">
              --仅创建者可修改--
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--我的项目二级页面-->
    <span class="myTask">
        <!--选择框-->
        <div v-if="exhibitLevel==2" class="selectPanel">
        <div style="float:right;width: 400px;height:30px;text-align:right;padding-right:20px;">
          <a-radio-group v-model="selectType" @change="selectTypeChange" name="radioGroup" :default-value="1">
            <a-radio :value="1">
              协同标注
            </a-radio>
            <!-- <a-radio :value="2">
              标注审核
            </a-radio> -->
            <a-radio :value="3" >
              外业核查
            </a-radio>
          </a-radio-group>
        </div>
      </div>
      <!--任务列表-->
        <div v-if="exhibitLevel==2" class="signUp_content">
        <!--协同标注，任务列表-->
          <!--selectType,1:协同标注，2：标注真核，3：外业核查-->
        <div v-if="selectType==1&&XTBZ_Stey==1" class="componentCtn-main">
          <div class="searchPanel">
            <div class="txt">
              任务名称:
            </div>
            <div class="input" style="padding-right: 20px;">
              <a-input size="large" style="height: 40px;font-size: 14px;" placeholder="请输入任务名称"
                       v-model="InputTaskName"/>
            </div>
            <div class="txt">
              任务状态:
            </div>
            <div class="input">
              <a-select size="large" style="height:40px;width:100%;font-size: 14px" placeholder="请选择任务状态"
                        v-model="InputTaskStatus">
                <a-select-option value="未开始">
                  未开始
                </a-select-option>
                <a-select-option value="进行中">
                  进行中
                </a-select-option>
                <a-select-option value="已完成">
                  已完成
                </a-select-option>
              </a-select>
            </div>
            <img src="../../assets/userCenter/查找.png" title="搜索" height="40" width="40" @click="search"
                 style="margin-left: 25px;cursor: pointer;"/>
            <img src="../../assets/userCenter/重置.png" title="重置" height="40" width="40" @click="reSet"
                 style="margin-left: 25px;cursor: pointer;"/>
<!--            <img src="../../assets/userCenter/添加任务.png" title="添加任务" height="40" width="40" @click="handleAdd"-->
<!--                 style="margin-left: 25px;cursor: pointer;"/>-->

          </div>
          <div class="tableCtn">
            <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="id"
                :columns="tableColumns"
                :dataSource="dataSource"
                :pagination="ipagination"
                @change="handleTableChange"
            >
            <span slot="markTags" slot-scope="text, record">
              <a-tag color="blue" v-for="(text,index) in record.markTags.slice(0,5)" :key="index">{{ text }}</a-tag>
            </span>
            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)" v-show="record.taskStatus == '未开始'">编辑</a>
              <a @click="handleDetail(record)" v-show="record.taskStatus != '未开始'">查看</a>
              <a-divider type="vertical"/>
              <a @click="handleTaskDetail(record)">详情</a>
              <a-divider type="vertical"/>
              <a-dropdown>
                <a class="ant-dropdown-link">更多 <a-icon type="down"/></a>
                <a-menu slot="overlay">
                  <a-menu-item v-show="record.taskStatus == '未开始'">
                    <a @click="handleMarker(record)">标注人员</a>
                  </a-menu-item>
                  <a-menu-item v-show="record.taskStatus == '未开始'">
                    <a @click="handleShenhe(record)">审核人员</a>
                  </a-menu-item>
                  <a-menu-item v-show="record.taskStatus == '未开始'">
                    <a @click="handleStart(record)">开始任务</a>
                  </a-menu-item>
                  <a-menu-item v-show="record.taskStatus == '进行中'">
                    <a-popconfirm title="确定结束任务吗?" @confirm="() => handleTaskOver(record)">
                      <a>结束任务</a>
                    </a-popconfirm>
                  </a-menu-item>
                  <a-menu-item>
                    <a-popconfirm title="确定删除吗?" ok-text="确定" cancel-text="取消"
                                  @confirm="() => handleDelete(record)">
                      <a>删除</a>
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </a-table>
            <!-- <a-table :columns="tableColumns" :data-source="tableData" style="font-weight: 700">
                <span slot="statusTags" slot-scope="status">
                  <a-tag
                      :color="status === '未开始' ? 'green' : status ==='进行中' ? 'blue' : 'volcano'"
                  >
                    {{ status }}
                  </a-tag>
                </span>
                <span slot="action" slot-scope="text, record">
                  <a v-if="record.status!='未开始'" @click="intoProject(record)">查看</a>
                  <a v-if="record.status=='未开始'" @click="intoProject(record)" style="color:#52c41a;">开始</a>
                  <a-divider type="vertical"/>
                  <a @click="showProjectDetail(record)">详情</a>
                  <a-divider type="vertical"/>
                  <a class="ant-dropdown-link"> 更多 <a-icon type="down"/> </a>
                </span>
            </a-table> -->
          </div>

        </div>
          <!--协同标注，iframe外接-->
        <div v-if="selectType==1&&XTBZ_Stey==2"
             :class="XTBZ_FullScreen?'componentCtn-main-fullScreen':'componentCtn-main'"
             :style="XTBZ_FullScreen?'':'margin-top: 30px;'">
          <div
              v-if="!XTBZ_FullScreen"
              @click="XTBZ_FullScreen=true"
              style="position:absolute;top:-30px;left:0px;height:30px;line-height:30px;width:100px;z-index:100000;cursor:pointer;color:#1f91f5;">
            <img src="../../assets/userCenter/全屏.png" height="32" width="32"/>
            全屏展示
          </div>
          <div
              v-if="XTBZ_FullScreen"
              @click='goHomeList'
              style="position:absolute;top:0px;left:0px;height:30px;line-height:30px;width:100px;z-index:100000;cursor:pointer;color:#1f91f5;">
            <!-- <img src="../../assets/userCenter/退出全屏.png" height="32" width="32"/>
            返回列表 -->
            <!-- <a-button>返回列表</a-button> -->
            <a-button style="background-color: #0091ff;color:white;top: 13px;left: 10px;">返回列表</a-button>
          </div>
          <iframe class="bash_iframe" :src=frameUrl
                  :style="XTBZ_FullScreen?'height:100%':'border-radius:16px;margin-bottom:10px;'">

          </iframe>


        </div>
          <!--标注审核-->
        <div v-if="selectType==2" :class="BZSH_FullScreen?'componentCtn-main-fullScreen':'componentCtn-main'"
             :style="BZSH_FullScreen?'':'margin-top: 30px;'">
          <div
              v-if="!BZSH_FullScreen"
              @click="BZSH_FullScreen=true"
              style="position:absolute;top:-30px;left:0px;height:30px;line-height:30px;width:100px;z-index:100000;cursor:pointer;color:#1f91f5;">
            <img src="../../assets/userCenter/全屏.png" height="32" width="32"/>
            全屏展示
          </div>
          <div
              v-if="BZSH_FullScreen"
              @click="BZSH_FullScreen=false"
              style="position:absolute;top:0px;left:0px;height:30px;line-height:30px;width:100px;z-index:100000;cursor:pointer;color:#1f91f5;">
            <img src="../../assets/userCenter/退出全屏.png" height="32" width="32"/>
            退出全屏
          </div>
          <iframe class="bash_iframe" :src=frameUrlOld
                  :style="BZSH_FullScreen?'height:100%':'border-radius:16px;margin-bottom:10px;'">

          </iframe>


        </div>
          <!--外业核查-->
          <div v-if="selectType==3" class="componentCtn-main">
          <div class="searchPanel">
            <div class="txt">
              任务名称:
            </div>
            <div class="input" style="padding-right: 20px;">
              <a-input v-model="wyhc_name" size="large" style="height: 40px;font-size: 14px;"
                       placeholder="请输入任务名称" />
            </div>
            <img src="../../assets/userCenter/查找.png" title="搜索" height="40" width="40" @click="getList_wyhc"
                 style="margin-left: 25px;cursor: pointer;" />
            <img src="../../assets/userCenter/重置.png" title="重置" height="40" width="40" @click="wyhc_name='';"
                 style="margin-left: 25px;cursor: pointer;" />
<!--            <img src="../../assets/userCenter/添加任务.png" title="添加任务" height="40" width="40"-->
<!--                 @click="handleAdd_wyhc"-->
<!--                 style="margin-left: 25px;cursor: pointer;" />-->

          </div>
          <div class="tableCtn">
            <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="id"
                :columns="wyhc_tableColumns"
                :dataSource="wyhc_dataSource"
                :pagination="wyhc_ipagination"
                @change="handleTableChange"
            >
            <span slot="markTags" slot-scope="text, record">
              <a-tag color="blue" v-for="(text,index) in record.markTags.slice(0,5)" :key="index">
                {{ text }}
              </a-tag>
            </span>
              <template slot="action" slot-scope="record">
                <!-- 在这里插入自定义的 HTML、组件或模板 -->
                <a @click="viewWYHCDetail(record)">详情</a>
              </template>
          </a-table>
            <!-- <a-table :columns="tableColumns" :data-source="tableData" style="font-weight: 700">
                <span slot="statusTags" slot-scope="status">
                  <a-tag
                      :color="status === '未开始' ? 'green' : status ==='进行中' ? 'blue' : 'volcano'"
                  >
                    {{ status }}
                  </a-tag>
                </span>
                <span slot="action" slot-scope="text, record">
                  <a v-if="record.status!='未开始'" @click="intoProject(record)">查看</a>
                  <a v-if="record.status=='未开始'" @click="intoProject(record)" style="color:#52c41a;">开始</a>
                  <a-divider type="vertical"/>
                  <a @click="showProjectDetail(record)">详情</a>
                  <a-divider type="vertical"/>
                  <a class="ant-dropdown-link"> 更多 <a-icon type="down"/> </a>
                </span>
            </a-table> -->
          </div>
        </div>
      </div>
      <!--任务详情对话框，我的任务-协同标注-->
        <a-modal v-model="projectDetailDialog"
                 :footer="null"
                 centered
                 width="667">
        <div style="width:667px;height:auto;min-height:200px;" class="detailCtn">
          <table class="table1">
            <tr class="tr1">
              <td class="td1" colspan="2">
                <span class="blod">
                  任务名称:
                </span>
                12312312312312312312312312312321
              </td>
            </tr>
            <tr class="tr1">
              <td class="td1">
                <span class="blod">
                  矢量来源:
                </span>
                123
              </td>
              <td class="td1">
                <span class="blod">
                  矢量类型:
                </span>
                123
              </td>
              <td class="td1">
                <span class="blod">
                  坐标系:
                </span>
                123
              </td>
            </tr>
            <tr class="tr1">
              <td class="td1">
                <span class="blod">
                  创建人:
                </span>
                123
              </td>
              <td class="td1">
                <span class="blod">
                  创建时间:
                </span>
                123
              </td>
              <td class="td1">
                <span class="blod">
                  任务状态:
                </span>
                123
              </td>
            </tr>
            <tr class="tr1">
              <td class="td1" colspan="3">
                <span class="blod">
                  任务标签:
                </span>
                <a-tag
                    :color="'blue'"
                >
                  123
                </a-tag>
              </td>

            </tr>
            <tr class="tr1">
              <td class="td1" colspan="3">
                <span class="blod">
                  标注人员:
                </span>
                <a-tag
                    :color="'red'"
                >
                  123
                </a-tag>
              </td>
            </tr>
            <tr class="tr1">
              <td class="td1" colspan="3">
                <span class="blod">
                  影像服务:
                </span>
                <a-tag
                    :color="'green'"
                >
                  123
                </a-tag>
              </td>
            </tr>

            <tr class="tr1">
              <td class="td1">
                <span class="blod">
                  标注总数:
                </span>
                <a-tag
                    :color="'blue'"
                >
                  123
                </a-tag>
              </td>
              <td class="td1">
                <span class="blod">
                  审核通过数量:
                </span>
                <a-tag
                    :color="'green'"
                >
                  123
                </a-tag>
              </td>
              <td class="td1">
                <span class="blod">
                  待审核数量:
                </span>
                <a-tag
                    :color="'red'"
                >
                  123
                </a-tag>
              </td>
            </tr>
          </table>
        </div>
        <template slot="title" style="border:none;">
          <div
              style="height:40px;line-height: 40px;font-size: 20px;font-weight: 700;border-left:5px solid #0091ff;padding-left: 15px;">
            详情
          </div>
        </template>
      </a-modal>
      </span>


    <!--新建外业核查对话框-->
    <a-modal v-model="wyhc_createModal"
             centered
             width="667">
      <div style="width:667px;height:auto;min-height:200px;">
        <div class="createProjectLine">
          <div class="item-name">
            任务名称
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <a-input v-model="wyhc_createData.name"
                     size="large" style="height: 40px;font-size: 14px;" placeholder="请填写项目名称"/>
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            项目描述
          </div>
          <div class="item-input">
            <a-textarea v-model="wyhc_createData.desp"
                        size="large" style="height: 60px;font-size: 14px" placeholder="请填写项目描述"/>
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            任务成员
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <a-select v-model="wyhc_createData.jl1UserId"
                      size="large" style="height:40px;width: 560px;font-size: 14px;"
                      placeholder="请选择要添加的项目成员">
              <a-select-option v-for="item in wyhc_userList" :key="item.jl1Account" :value="item.jl1Account">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
        </div>

        <div class="createProjectLine">
          <div class="item-name">
            上传文件
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
                <div class="vectorPanel_1" >
                  <a-upload-dragger
                      name="file"
                      accept=".zip,.ZIP"
                      @change="handleFileChange_wyhc"
                  >
                    <p class="ant-upload-drag-icon">
                      <a-icon type="inbox" />
                    </p>
                    <p class="ant-upload-text">
                      点击或拖动文件上传
                    </p>
                    <p class="ant-upload-hint" style="color:#faa002;">
                      文件必须为zip格式，坐标采用国家2000，请注意字段对应及数据标准，文件大小不超过50M
                    </p>
                  </a-upload-dragger>
                </div>
          </div>
        </div>


      </div>
      <template slot="footer">
        <a-button type="primary" @click="clickCreateWYHC">
          创建
        </a-button>
        <a-button @click="wyhc_createModal=false;showVectoryCheckLoading=false;">
          取消
        </a-button>
      </template>
      <template slot="title" style="border:none;">
        <div
            style="height:40px;line-height: 40px;font-size: 20px;font-weight: 700;border-left:5px solid #0091ff;padding-left: 15px;">
          新建外业核查任务
        </div>
      </template>
    </a-modal>
    <!--关闭项目对话框-->
    <a-modal v-model="closeProjectModal"
             centered
             width="490"
    >
      <div style="width:490px;height:70px;margin-top: 20px;">
        <div style="float:left;width:63px;height: 63px;">
          <img src="../../assets/userCenter/我的项目-注意.png" height="63" width="63"/>
        </div>
        <div
            style="float:left;width: calc(100% - 63px);height:63px;line-height: 31px;padding-left: 20px;font-size:20px;font-weight: 600;">
          关闭后将无法访问该项目，请谨慎操作。 <br/>
          确定关闭项目 {{closeProjectName}} ?
        </div>
      </div>
      <template slot="footer">
        <a-button @click="confirmCloseProject()" type="danger">
          确定
        </a-button>
        <a-button @click="closeProjectModal=false">
          取消
        </a-button>
      </template>
    </a-modal>
    <!--分享链接对话框-->
    <a-modal v-model="shareLinkModal"
             centered
             width="690"
             >
      <div style="display:flex;justify-content:left;width:690px;height:auto;min-height:100px;margin-top: 35px;">
        <div style="width:63px;height: 63px;margin-top: 15px;">
          <img src="../../assets/userCenter/我的项目-分享管理.png" height="63" width="63"/>
        </div>
        <div class="shareListCtn">
            <span v-for="(item,i) in shareList" :key="item.mk_id">
                <span style="font-weight: bold">
                  <img @click="initMap(item.name,`${item.url}&vf=0`)" src="../../assets/userCenter/查看.png" height="20" width="30" style="cursor:pointer;margin-top: -4px;"/>
                  &nbsp;{{ i + 1 }}.图层“{{ item.name }}”,服务链接：</span><br/>
                {{ item.url }}<br/><br/>
            </span>
        </div>
      </div>
      <template slot="footer">
        <a-button @click="exportShareList" type="primary">
          全部导出
        </a-button>
        <a-button @click="shareLinkModal=false">
          关闭
        </a-button>
      </template>
    </a-modal>
    <!--创建项目对话框-->
    <a-modal v-model="createProjectModal"
             centered
             width="667">
      <div style="width:667px;height:auto;min-height:500px;">
        <div class="createProjectLine">
          <div class="item-name">
            项目名称
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <a-input v-model="addProjectData.name"
                     size="large" style="height: 40px;font-size: 14px;" placeholder="请填写项目名称"/>
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            项目描述
          </div>
          <div class="item-input">
            <a-textarea v-model="addProjectData.description"
                        size="large" style="height: 60px;font-size: 14px" placeholder="请填写项目描述"/>
          </div>
        </div>
        <!-- <div class="createProjectLine">
          <div class="item-name">
            项目团队
          </div>
          <div class="item-input">
            <a-select v-model="addProjectData.group_id"
                      size="large" style="height:40px;width: 560px;font-size: 14px;"
                      placeholder="请选择要添加的项目成员">
              <a-select-option v-for="item in teamList" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
        </div> -->
        <div class="createProjectLine">
          <div class="item-name">
            项目有效期
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <a-range-picker
                :placeholder="['开始日期','结束日期']"
                size="large"
                :locale="locale"
                style="height:40px;width: 560px;font-size: 14px;"
                :disabled-date="disabledDate"
                v-model="tempTime"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD">
            </a-range-picker>
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            选择套件
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <CascaderSelect
                :key="'CascaderSelect'+CascaderSelectId"
                allowClear
                style="width:100%;height:40px"
                :maxTagCount="3"
                :maxTagTextLength="4"
                placeholder="请选择"
                :selectOptionsConfig="{
                    key: 'id',
                    value: 'id',
                    text: 'name',
                    children: 'mkList'
                    }"
                  noDataText="暂无数据"
                  :treeData="[multipleTreeData]"
                  @handleCheckboxChange="handleCheckboxChange"
              />
          </div>
          </div>
        <div class="createProjectLine">
            <div class="item-name">
              选择矢量
              <img src="../../assets/userCenter/必填标志.png"
                   style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
            </div>
            <div class="item-input">
              <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="在矢量库中选择" >
                  <div class="vectorPanel">
                    <a-checkbox-group v-model="addProjectData.shape_ids" style="width: 100%">
                      <div v-for="item in vectorList" :key="item.id" class="itemCtn">
                        <a-checkbox style="color:#000000" :value="item.id" :disabled="Number(item.nrings)>15">
                          {{ item.name }}
                        </a-checkbox>
                        <a-tag color="blue" style="float:right;margin-top: 5px;cursor: pointer" @click="checkAndShow(item.id)">
                          查看
                        </a-tag>
                      </div>
                    </a-checkbox-group>
                  </div>
                </a-tab-pane>
                <a-tab-pane key="2" tab="上传矢量" disabled>
                  Content of Tab Pane 2
                </a-tab-pane>
                <a-tab-pane key="3" tab="勾画矢量" disabled>
                  Content of Tab Pane 3
                </a-tab-pane>
              </a-tabs>
            </div>
          </div>


      </div>
      <template slot="footer">
        <a-button type="primary" @click="clickCreateProject">
          创建
        </a-button>
        <a-button @click="createProjectModal=false">
          取消
        </a-button>
      </template>
      <template slot="title" style="border:none;">
        <div
            style="height:40px;line-height: 40px;font-size: 20px;font-weight: 700;border-left:5px solid #0091ff;padding-left: 15px;">
          创建项目
        </div>
      </template>
    </a-modal>
    <!--编辑项目对话框-->
    <a-modal v-model="editProjectModal"
             centered
             width="667">
      <template slot="title" style="border:none;">
        <div
            style="height:40px;line-height: 40px;font-size: 20px;font-weight: 700;border-left:5px solid #0091ff;padding-left: 15px;">
          编辑项目
        </div>
      </template>
      <div style="width:667px;height:auto;min-height:500px;">
        <div class="createProjectLine">
          <div class="item-name">
            项目名称
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <a-input v-model="editProjectData.name"
                     size="large" style="height: 40px;font-size: 14px;" placeholder="请填写项目名称"/>
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            项目描述
          </div>
          <div class="item-input">
            <a-textarea v-model="editProjectData.description"
                        size="large" style="height: 60px;font-size: 14px" placeholder="请填写项目描述"/>
          </div>
        </div>
        <!-- <div class="createProjectLine">
          <div class="item-name">
            项目团队
          </div>
          <div class="item-input">
            <a-select v-model="editProjectData.group_id"
                      size="large" style="height:40px;width: 560px;font-size: 14px;"
                      placeholder="请选择要添加的项目成员">
              <a-select-option v-for="item in teamList" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
        </div> -->
        <div class="createProjectLine">
          <div class="item-name">
            项目有效期
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <a-range-picker
                :placeholder="['开始日期','结束日期']"
                size="large"
                :locale="locale"
                style="height:40px;width: 560px;font-size: 14px;"
                :disabled-date="disabledDate"
                v-model="tempTime_edit"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD">

            </a-range-picker>
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            选择套件
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <div class="edit-tj-ctn">
              <div v-for="item in editProjectData.edit_repository" :key="item.id" class="item-ctn">
                <div class="tj-title">
                  {{item.name}}:
                </div>
                <div class="mk-ctn">
                  <div v-for="mk_item in item.mks" :key="mk_item.id" class="mk-item">
                    {{mk_item.name}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            选择矢量
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <a-tabs default-active-key="1" >
              <a-tab-pane key="1" tab="在矢量库中选择" disabled>
                <div class="vectorPanel" style="height:100px;">
<!--                  <div style="width:100%;height: 100px;line-height: 100px;text-align: center">-->
<!--                    已选矢量不可更改-->
<!--                  </div>-->
                 <a-checkbox-group  style="width: 100%">
                    <div v-for="item in editProjectData.shapes" :key="item.id" class="itemCtn">
                      <a-checkbox style="color:#000000" :value="item.id" disabled>
                        {{ item.name }}
                      </a-checkbox>
                      <a-tag color="blue" style="float:right;margin-top: 5px;cursor: pointer" @click="checkAndShow(item.id)">
                        查看
                      </a-tag>
                    </div>
                  </a-checkbox-group>
                </div>
              </a-tab-pane>
              <a-tab-pane key="2" tab="上传矢量" disabled>
                Content of Tab Pane 2
              </a-tab-pane>
              <a-tab-pane key="3" tab="勾画矢量" disabled>
                Content of Tab Pane 3
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>


      </div>
      <template slot="footer">
        <a-button type="primary" @click="clickConfirmEditProject">
          确认
        </a-button>
        <a-button @click="editProjectModal=false">
          取消
        </a-button>
      </template>

    </a-modal>
    <!--确认创建项目对话框-->
    <a-modal v-model="confirmCreateProjectModal"
             centered
             width="490"
             >
      <div
          style="display:flex;justify-content:left;width:490px;min-height:60px;height:auto;padding-bottom:10px;margin-top: 20px;">
        <div style="width:63px;height: 63px;">
          <img src="../../assets/userCenter/我的项目-注意.png" height="63" width="63"/>
        </div>
<!--        <div-->
<!--            style="width: calc(100% - 63px);min-height:63px;line-height: 31px;height:auto;padding-left: 20px;font-size:20px;font-weight: 600;">-->
<!--          当前套件的剩余面积额度<span style="color:#E02020;">7万km<sup>2</sup></span><br/>-->
<!--          创建后只可增加不可删除，请谨慎选择。 <br/>-->
<!--          确定创建项目 遥感开发者在线标注项目 ?-->
<!--        </div>-->
        <div class="shareListCtn">
            <span v-for="item in repositoryRemainlist" :key="item.repository_id">
              <span v-if="item.repository_name!='体验版'">
                 当前套件“{{item.repository_name}}”的剩余面积额度为<span style="color:#E02020;">{{(item.curRemainArea).toFixed(2)}}km<sup>2</sup></span>;<br/>
              </span>
            </span>
            <span v-for="item in vectorBufferedList" :key="item.id">
              <span v-if="item.new_area">矢量“{{item.shape_name}}”中有要素面积不足25平方公里，将自动扩充，详情请点击查看按钮;<br/></span>
            </span>
          创建后只可增加不可删除，请谨慎选择。确定创建项目: {{addProjectData.name}}?
        </div>
        
      </div>
      <template slot="footer">
        <a-button @click="confirmCreateProject()" type="danger">
          确定
        </a-button>
        <a-button @click="confirmCreateProjectModal=false">
          取消
        </a-button>
      </template>
    </a-modal>
    <!--矢量与套件无相交-->
    <a-modal v-model="noIntersectModal"
             centered
             width="490"
             >
      <div
          style="display:flex;justify-content:left;width:490px;min-height:60px;height:auto;padding-bottom:10px;margin-top: 20px;">
        <div style="width:63px;height: 63px;">
          <img src="../../assets/userCenter/我的项目-注意.png" height="63" width="63"/>
        </div>
        <!--        <div-->
        <!--            style="width: calc(100% - 63px);min-height:63px;line-height: 31px;height:auto;padding-left: 20px;font-size:20px;font-weight: 600;">-->
        <!--          当前套件的剩余面积额度<span style="color:#E02020;">7万km<sup>2</sup></span><br/>-->
        <!--          创建后只可增加不可删除，请谨慎选择。 <br/>-->
        <!--          确定创建项目 遥感开发者在线标注项目 ?-->
        <!--        </div>-->
        <div v-if="noIntersectResponse.intersectShapes.length>0"  class="shareListCtn" style="line-height: 60px;">
          您选择的矢量列表中仅{{noIntersectResponse.intersectShapes}}与所选套件{{noIntersectResponse.intersectMks}}有相交区域，请去除多余矢量或套件后重新提交。
        </div>
        <div v-if="noIntersectResponse.intersectShapes.length==0&&noIntersectResponse.intersectMks.length==0"  class="shareListCtn" style="line-height: 60px;">
          您选择的套件和矢量无相交区域，请重新选择。
        </div>
      </div>
      <template slot="footer">
        <a-button @click="noIntersectModal=false">
          重新选择
        </a-button>
      </template>
    </a-modal>


    <!-- 新建标注样本表单区域 -->
    <new-shp-modal ref="modalForm"></new-shp-modal>

    <!-- 在线标注人员列表 -->
    <marker-modal ref="markerModalForm"></marker-modal>

    <!-- 在线标注人员列表 -->
    <shenhe-modal ref="shenheModalForm"></shenhe-modal>

    <!-- 外业核查任务详情 -->
    <a-modal
        title="详情"
        :width="800"
        :visible="YYHC_Detail"
        :footer="null"
        :mask='false'
        :maskClosable='false'
        @cancel="yyhc_handleCancel"
        cancelText="关闭">
      <a-spin :spinning="confirmLoading">
        <a-card :bordered="false" :body-style="{padding: 0}">
          <detail-list>
            <detail-list-item term="任务名称" style="width:100%;">{{ YYHC_Detail_Data.name }}</detail-list-item>
            <detail-list-item term="外业人员" style="width:100%;">
              <a-tag color="red" v-for="(text,index) in YYHC_Detail_Data.checkUserNameList" :key="index">{{ text }}</a-tag>
            </detail-list-item>
            <detail-list-item term="审核人员" style="width:100%;">
              <a-tag color="Thistle" v-for="(text,index) in YYHC_Detail_Data.examineUserNameList" :key="index">{{ text }}</a-tag>
            </detail-list-item>
            <detail-list-item term="任务描述" style="width:100%;">
              {{YYHC_Detail_Data.desp}}
            </detail-list-item>
          </detail-list>
        </a-card>
      </a-spin>
    </a-modal>
    <!-- 标注任务详情 -->
    <a-modal
        title="详情"
        :width="800"
        :visible="visible"
        :confirmLoading="confirmLoading"
        :footer="null"
        :mask='false'
        :maskClosable='false'
        @cancel="handleCancel"
        cancelText="关闭">
      <a-spin :spinning="confirmLoading">
        <a-card :bordered="false" :body-style="{padding: 0}">
          <detail-list>
            <detail-list-item term="任务名称" style="width:100%;">{{ model.taskName }}</detail-list-item>
            <!-- <detail-list-item term="矢量来源">{{model.taskType_dictText}}</detail-list-item> -->
            <detail-list-item term="矢量类型">{{ model.geometryType }}</detail-list-item>
            <detail-list-item term="坐标系">{{ model.coordinateSystem }}</detail-list-item>
            <!-- <detail-list-item term="创建人">{{model.createBy}}</detail-list-item> -->
            <!-- <detail-list-item term="创建时间">{{model.createTime}}</detail-list-item> -->
            <detail-list-item term="任务状态">{{ model.taskStatus }}</detail-list-item>
            <detail-list-item term="任务标签" style="width:100%;">
              <a-tag color="blue" v-for="(text,index) in model.markTags" :key="index">{{ text }}</a-tag>
            </detail-list-item>
            <detail-list-item term="标注人员" style="width:100%;">
              <a-tag color="red" v-for="(text,index) in this.taskUsers" :key="index">{{ text }}</a-tag>
            </detail-list-item>
            <detail-list-item term="审核人员" style="width:100%;">
              <a-tag color="Thistle" v-for="(text,index) in this.aduitUsers" :key="index">{{ text }}</a-tag>
            </detail-list-item>
            <detail-list-item term="影像服务" style="width:100%;">
              <a-tag color="green" v-for="(text,index) in this.taskImages" :key="index">{{ text }}</a-tag>
            </detail-list-item>
            <!--<detail-list-item term="标注总数">
              <a-tag color="blue">{{ this.totalAmount }}</a-tag>
            </detail-list-item>
            <detail-list-item term="审核通过数量">
              <a-tag color="green">{{ this.checkedAmount }}</a-tag>
            </detail-list-item>
            <detail-list-item term="待审核数量">
              <a-tag color="red">{{ this.unCheckAmount }}</a-tag>
            </detail-list-item> -->
          </detail-list>
        </a-card>
      </a-spin>
    </a-modal>

        <!--查看矢量对话框-->
        <a-modal v-model="viewVectorModal"
             centered width="660px" :header="null"
             :footer="null"
        >
          <!-- <div class="createVectorTitle">
            <span style="float:left">创建新矢量</span>
            <div style="width: 500px;height: 40px;line-height: 40px;font-size: 14px;color: #979797;float:left;margin-left:400px;">
              当前时间：{{nowTime}}
            </div>
          </div> -->
          <div class="overviewVectorDiv"  style="position:relative;z-index: 1000000;">
            <l-map
                :maxBounds="maxBounds"
                :minZoom="parseInt(2)"
                ref="map"
                style="width: 100%; height: 100%;z-index: 1000000;"
                :zoom="zoom"
                :center="center"
                :options="option"
                :class="$store.state.search.targetSelecting ? 'leaflet-crosshair': ''"
            >
                <template mark="map">
                    <l-tile-layer ref="mapLayer" :url="$store.state.map.mapUrl" :options="$store.state.map.mapSubdomains" />
                    <l-tile-layer ref="infoLayer" v-show="!!$store.state.map.infoUrl" :url="$store.state.map.infoUrl"  :options="$store.state.map.mapSubdomains" />
                </template>
                <l-geo-json
                        v-if="bufferGeo.geojson"
                        :geojson="bufferGeo.geojson"
                        :optionsStyle="bufferGeojsonStyle"
                ></l-geo-json>

                <l-geo-json
                        v-if="overviewGeo.geojson"
                        :geojson="overviewGeo.geojson"
                        :optionsStyle="targetGeojsonStyle"
                ></l-geo-json>
            </l-map>
          </div>

        </a-modal>
    <div v-if="showVectoryCheckLoading" style="position: fixed;top:50%;left:50%;z-index:10000000;">
      <a-spin tip="矢量检验中..." />
    </div>

    <!--地图弹窗-->
    <div class="text-center" v-if="mapdialog" style="z-index:1001">
      <v-dialog v-model="mapdialog" width="100vw" height="100vh" content-class="mapDialog">
          <v-card
          height="100vh"
          style="position: relative;width: calc(100vw - 8px);padding: 1px;z-index:1001;"
          >
          <!--关闭标签-->
          <img
              style="position: absolute; top: 25px;right:30px;z-index:1; cursor: pointer"
              src="~@/assets/RSsserviceManage/关闭.png"
              height="40"
              width="40"
              @click="mapdialog = false;juanlianOpen=false"
          />
              <!-- <div id="cgmapmk"></div> -->
              <div class="mapdiv">
                  <pl-lazy>
                      <main-map
                      ref="mainmap"
                      :lyrdata="lyrdata"
                      :mapCtrlTools="mapCtrlTools4Use"
                      :mapParams="mapParams"
                      >
                      </main-map>
                  </pl-lazy>
              </div>
          </v-card>
      </v-dialog>
    </div>
    <v-overlay :value="overlay" :z-index="10000">
      <span>正在处理，请稍后</span>
      <v-progress-circular indeterminate size="32"></v-progress-circular>
    </v-overlay>
    </div>
</template>

<script>
    import moment from 'moment';
    import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
    import NewShpModal from './NewShpModal'
    import MarkerModal from './MarkerModal'
    import ShenheModal from './ShenheModal'
    import { bus } from '@/bus.js' //引入bus.js定义的空的Vue实例
    import DetailList from '@/components/tools/DetailList'
    import CascaderSelect from '@/components/Cascader/Cascader.vue'

    // import handle from "ant-design-vue/lib/vc-slider/src/Handle";
    // import MainMap from '@/components/Maps/MainMap'
    // import SearchRangeSelector from '@/components/Maps/SearchVector/SearchRangeSelector'
    import L from 'leaflet'
    import { LMap,LMarker,LTileLayer,LGeoJson,LWMSTileLayer} from 'vue2-leaflet'
    import 'leaflet-mouse-position'
    import MainMap from '@/components/Maps/MainMap'
    
    const DetailListItem = DetailList.Item
    export default {
        name: "SignUp",
      components: {
        NewShpModal,
        MarkerModal,
        DetailList,
        DetailListItem,
        ShenheModal,
        CascaderSelect,
        LMap,
        LTileLayer,
        LGeoJson,
        MainMap
      },
        data(){
            return{
              dataList:[],
              closeProjectModal:false,//关闭项目
              closeProjectId:'',//关闭项目id
              closeProjectName:'',
              shareLinkModal:false,//分享项目
              createProjectModal:false,//创建项目
              confirmCreateProjectModal:false,//确认创建项目
              editProjectModal:false,//编辑项目
              locale,//时间插件文字中文
              exhibitLevel:1,//展现层级
              repositoryExamplse: {
                "list": [{
                  "id": "91870dad63384e5488f2f169f7a8f402",
                  "mk_ids": ["315920d6259b45a985511c329d23ef50", "01238ef3fbb346d28f4446527b6102b4"]
                }]
              },
              groupId_currentProject:'',//当前项目groupId
              currentProject:{},
              //项目列表
              projectList:[],//项目列表
              //以下是新增项目相关字段
              addProjectData:{
                name:'',
                start_time:'',
                end_time:'',
                description:'',
                shape_ids:[],//矢量库选择的矢量
                group_id:'',
                repository:{list:[]},//套件与选择的图层
                geojson:'',//上传矢量或勾画矢量
              },
              tempTime:[],//时间选择器
              vectorList:[],//矢量列表
              teamList:[],//团队列表
              repositoryMultipleTreeData:[],
              repositoryRemainlist:[],//套件使用情况
              vectorBufferedList:[],//矢量外扩情况
              showVectoryCheckLoading:false,//数据检验中
              noIntersectModal:false,//无相交
              noIntersectResponse:{
                intersectShapes:[],
                intersectMks:[]
              },
              CascaderSelectId:1,
              //以下是编辑项目字段
              editProjectData:{
                program_id:'',
                name:'',
                start_time:'',
                end_time:'',
                description:'',
                shape_ids:[],//矢量库选择的矢量
                group_id:'',
                repository:{},//套件与选择的图层
                geojson:'',//上传矢量或勾画矢量
              },
              tempTime_edit:[],
              editTree:[],
              //分享项目
              shareList:[],
              //外业核查相关字段
              YYHC_Detail:false,
              YYHC_Detail_Data:{},
              wyhc_tableColumns:[
                {
                  title: '任务名称',
                  align: 'center',
                  dataIndex: 'name'
                },
                {
                  title: '创建时间',
                  align: 'center',
                  dataIndex: 'createTime'
                },
                {
                  title: '图斑总数',
                  align: 'center',
                  dataIndex: 'totalSum',
                },
                {
                  title: '已核查个数',
                  align: 'center',
                  dataIndex: 'checkSum'
                },
                {
                  title: '未核查个数',
                  align: 'center',
                  dataIndex: 'uncheckSum'
                },
                {
                  title: '创建者',
                  align: 'center',
                  dataIndex: 'userName'
                },
                {
                  title: '操作',
                  scopedSlots: { customRender: 'action' }, // 指定插槽的名称为 'action'
                },
              ],
              wyhc_dataSource:[],
              wyhc_name:'',
              wyhc_ipagination:{
                current: 1,
                pageSize: 10,
                // pageSizeOptions: ['10', '20', '30'],
                showTotal: (total, range) => {
                  return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                // showSizeChanger: true,
                total: 0
              },
              wyhc_createModal:false,
              wyhc_createData:{
                name:'',
                desp:"",
                jl1UserId:'',
                programId:'',
                importShapeFile:''
              },
              // uploadFile:null,
              wyhc_userList:[],
              //以下为任务字段
              selectType:1,//1：协同标注，2：标注审核；3.外业核查
              tableColumns:[
                // {
                //   title: '序号',
                //   dataIndex: '',
                //   key: 'rowIndex',
                //   align: 'center',
                //   customRender: function(t, r, index) {
                //     return parseInt(index) + 1
                //   }
                // },
                {
                  title: '任务名称',
                  align: 'center',
                  dataIndex: 'taskName'
                },
                // {
                //   title: '标签',
                //   dataIndex: 'markTags',
                //   align: 'center',
                //   scopedSlots: { customRender: 'markTags' },

                // },
                // {
                //   title: '标注类型',
                //   align: 'center',
                //   dataIndex: 'geometryType_dictText',
                // },
                // {
                //   title: '创建人',
                //   align: 'center',
                //   dataIndex: 'createBy',
                // },
                {
                  title: '创建时间',
                  align: 'center',
                  dataIndex: 'createTime',
                },
                {
                  title: '状态',
                  align: 'center',
                  dataIndex: 'taskStatus',
                },
                {
                  title: '操作',
                  align: 'center',
                  dataIndex: 'action',
                  scopedSlots: { customRender: 'action' }
                }
              ],
              dataSource:[],
              /* 分页参数 */
              ipagination:{
                current: 1,
                pageSize: 10,
                // pageSizeOptions: ['10', '20', '30'],
                showTotal: (total, range) => {
                  return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                // showSizeChanger: true,
                total: 0
              },
              /* 排序参数 */
              isorter:{
                column: 'createTime',
                order: 'desc',
              },
              projectDetailDialog:false,//任务详情
              XTBZ_Stey:1,//协同标注步骤，1：列表，2：外接
              XTBZ_FullScreen:false,//协同标注-我的任务，全屏
              BZSH_FullScreen:false,//标注审核-我的任务，全屏
              projectId:'',
              visible:false,
              confirmLoading: false,
              model:{},
              InputTaskName:'',
              InputTaskStatus:'',
              taskUsers:[],
              aduitUsers:[],
              taskImages:[],
              
              // frameBaseUrl:'https://storedev.jl1.cn/gisworkbench',
              frameBaseUrl:'https://www.jl1mall.com/gisworkbench',
              frameUrl:this.frameBaseUrl + '/analysisTask/SampleLabelAudit',
              frameUrlOld:this.frameBaseUrl + '/analysisTask/SampleLabelAudit',
              // frameBaseUrl:'http://10.200.30.19:3000/gisworkbench',
              // frameUrl:this.frameBaseUrl + '/jl1_workplace/analysisTask/SampleLabelAudit',
              // frameUrlOld:this.frameBaseUrl + '/jl1_workplace/analysisTask/SampleLabelAudit',
              multipleTreeData: [

              ],
              selectTaojian: [],



              // leaflet参数
              // targetModePoint: L.latLng(380, 90),
              targetMode: false,
              zoom: 4,
              center: L.latLng(33.978292, 105.395057),
              maxBounds: L.latLngBounds([[85,-180], [-85,180]]),
              url: this.$store.state.mapUrl,
              subdomains: this.$store.state.mapSubdomains,
              option: { zoomControl: false, attributionControl: false, renderer: L.canvas() },
              // showSearchRangeSelector: false,

              targetGeojsonStyle: {
                  color: '#00BCD4',
                  weight: 2,
                  fillOpacity: 0
              },
              bufferGeojsonStyle: {
                  color: '#F44336',
                  fillColor: '#F44336',
                  weight: 2,
                  fillOpacity: 0.1
              },
              bufferGeo: {
                geojson: '',
                area:''
              },
              overviewGeo: {
                geojson: '',
                id:''
              },

              viewVectorModal: false,


              //地图
              mapdialog:false,
              tileBaseUrl:'https://api.jl1mall.com',
              lyrdata: [
                  {
                      lyrType:"Tile",
                      srcType:"XYZ",
                      mUrl:`${this.tileBaseUrl}/getMap/{z}/{x}/{-y}?mk=2d9bf902749f1630bc25fc720ba7c29f&tk=${this.tk}&vf=0`,
                      mTitle:"全球一张图",
                      mName:"全球一张图",
                      mExtent:['73.5013','3.4065','135.0961','53.5632'],
                      mVisible:true
                  },
                  {
                      lyrType:"Tile",
                      srcType:"XYZ",
                      mUrl:"",
                      mTitle:"",
                      mName:"",
                      mExtent:[],
                      mVisible:true
                  },
                  // {
                  //     lyrType: "Tile",
                  //     srcType: "XYZ",
                  //     mUrl: "https://t{0-7}.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=a1acdff888c05743e3603302c3f64a6d",
                  //     mTitle: "文字标注",
                  //     mName: "文字标注",
                  //     mVisible: false
                  // }
                  // {
                  //     lyrType: "MapboxVectorLayer",
                  //     srcType: "MapboxVectorLayer",
                  //     // mUrl: "https://earth.jl1.cn/symboltile/placetile",
                  //     mTitle: "文字标注",
                  //     mName: "文字标注",
                  //     mVisible: true
                  // }
              ],
              mapCtrlTools4Use: [2],
              mapParams: {
                  projection:'EPSG:3857', //注意：必须加上此投影才能显示地图，目前有效的是4326和3857，而4490暂未生效
                  center:[108.29883, 35.72902], //地图初始化时的中心坐标【基于4326坐标系】
                  // center:[142.85524, 43.61710], //地图初始化时的中心坐标【基于4326坐标系】
                  // mExtent:[120.45536,35.55856,139.36943,44.78707], //左下点-右上点
                  minZoom:1, //可以缩小的最小级别；若此处未定义，地图接收到undefined则表示不受限制
                  maxZoom:18, //可以放大的最大级别；若此处未定义，地图接收到undefined则表示不受限制
                  zoom:4, //地图初始化时显示级别；注意：若此处未定义，地图初始化显示不出来
              },

              overlay: false,


            }
        },
        created() {
        },
  methods: {
    getTodayTime() {
      let dateTime = new Date();
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      if(month< 10){ month="0" +month }
      let ri = dateTime.getDate();
      if(ri< 10){ ri="0" +ri }
      let hours = dateTime.getHours();
      if(hours< 10){ hours="0" +hours }
      let minutes=dateTime.getMinutes();
      if(minutes< 10){ minutes="0" +minutes }
      let seconds=dateTime.getSeconds();
      if (seconds < 10) { seconds = "0" + seconds }
      let time = year + "-" + month + "-" + ri + " " + hours + ":" + minutes + ":" + seconds
      return time;
    },
    async initMap(title, url) {
        
        let tk = url.match(/tk=(\S*)&pro/)[1]; 
        let mk = url.match(/mk=(\S*)&tk/)[1]; 
        let pro = url.match(/pro=(\S*)&vf/)[1]; 
        // let bbox=bbox.split(',').map(Number)
        let param=new FormData();
        param.append('program_id',pro);
        param.append('mk', mk);
        let bbox ,programGeoJson,intersectionGeoJson
        await this.axios.post("/map_service_back/program/getExtentByProgram", param,{
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        }).then((response) => {
          if (response.data.data) {
              console.log('response.data',response.data)
                let extOld = response.data.data
                programGeoJson = response.data.programGeoJson
                intersectionGeoJson = response.data.intersectionGeoJson
                extOld = extOld.split(',')
                bbox = [parseFloat(extOld[0]), parseFloat(extOld[1]), parseFloat(extOld[2]), parseFloat(extOld[3])]
                Promise.resolve() //如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
                
            }
        }).catch(function(error) {
          console.log(error)
        })

        this.lyrdata = [{
            lyrType:"Tile",
            srcType:"XYZ",
            mUrl:url,
            mTitle:title,
            mName:title,
            mExtent:bbox,
            mVisible:true
        },
        // {
        //     lyrType: "MapboxVectorLayer",
        //     srcType: "MapboxVectorLayer",
        //     mTitle: "文字标注",
        //     mName: "文字标注",
        //     mVisible: true
        // }
        ]
        // if (title!="2022年度全国高质量一张图") {
        //   this.lyrdata.unshift({
        //       lyrType:"Tile",
        //       srcType:"XYZ",
        //       mUrl:`${this.tileBaseUrl}/getMap/{z}/{x}/{-y}?mk=2d9bf902749f1630bc25fc720ba7c29f&tk=${tk}&vf=0`,
        //       mTitle:"2022年度全国高质量一张图",
        //       mName:"2022年度全国高质量一张图",
        //       mExtent:['73.5013','3.4065','135.0961','53.5632'],
        //       mVisible:true
        //   })
          
        // }
        this.lyrdata.push({
            lyrType:"lVector",
            srcType:"Vector",
            mUrl:intersectionGeoJson,//相交的geojson
            mTitle:"边框",
            mName:"边框",
            mVisible:true
        })
        this.mapdialog=true
    },
    //外业核查详情
    viewWYHCDetail:function (record) {
      console.log(record);
      this.axios
          .get("/tilesapi/tiles/task/field/task/getById?taskId="+record.id,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('外业核查详情：');
        console.log(response);
        this.YYHC_Detail_Data=response.data.data;
      })
      this.YYHC_Detail=true;

    },
    yyhc_handleCancel:function () {
      this.YYHC_Detail=false;
      this.YYHC_Detail_Data={};
    },
          //外业核查列表改变
    wyhc_ListChange:function (pagination, filters, sorter){
      console.log(pagination)
      console.log(filters)
      console.log(sorter)
      this.wyhc_ipagination.current=pagination.current;
      this.wyhc_ipagination.pageSize=pagination.pageSize;
      this.getList_wyhc();
    },
          //获取外业核查列表
    getList_wyhc:function () {
      let param=new FormData();
      param.append('programId',this.currentProject.id);
      param.append('taskName',this.wyhc_name);
      param.append('pageNo',this.wyhc_ipagination.current);
      param.append('pageSize',this.wyhc_ipagination.pageSize);
      this.axios
          .post("/tilesapi/tiles/task/field/task/list", param,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('外业核查列表');
        console.log(response);
        this.wyhc_dataSource=response.data.data.records;

    })
    },
    //创建外业核查
          clickCreateWYHC:function(){
      if(!this.wyhc_createData.name){
        this.$message.error('请填写任务名')
        return;
      }
      if(!this.wyhc_createData.jl1UserId){
        this.$message.error('请选择成员')
        return;
      }
      if(!this.wyhc_createData.importShapeFile){
        this.$message.error('请上传矢量文件')
        return;
      }
      let param=new FormData();
      param.append('name',this.wyhc_createData.name);
      param.append('desp',this.wyhc_createData.desp);
      param.append('programId',this.currentProject.id);
      param.append('jl1UserId',this.wyhc_createData.jl1UserId);
      param.append('importShapeFile',this.wyhc_createData.importShapeFile);
      this.axios
          .post("/tilesapi/tiles/task/field/task/importShapeFile", param,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('创建外业核查')
        console.log(response)
        if(response.data.code==200){
          this.$message.success(response.data.msg)
          this.getList_wyhc();//获取外业核查列表
          this.wyhc_createModal=false
        }
        else {
          this.$message.error(response.data.msg)
        }
      })
    },
    //获取团队成员列表
    getMembersList:function (){
      let param=new FormData();
      param.append('JL1Account','');
      param.append('name','');
      param.append('status','');
      param.append('groupId',this.currentProject.group_id);
      param.append('pageSize',1000);
      param.append('pageNo',1);
      this.axios
          .post("/tilesapi/tiles/member/list", param,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('获取团队成员1111111')
        console.log(response)
        this.wyhc_userList=response.data.data.records;
      })
    },
          //外业核查，文件上传
    handleFileChange_wyhc:function (data) {
      console.log("外业核查，文件上传")
      console.log(data)
      this.wyhc_createData.importShapeFile=data.file.originFileObj;
    },
          //点击新建外业核查
    handleAdd_wyhc:function () {
      this.$router.push("/fieldWorkCreateProject")
      // this.wyhc_createModal=true;
    },
    //导出分享链接
    exportShareList: function () {
      let dataList=this.shareList;
      let str='名称,地址\n';
      // 增加\t为了不让表格显示科学计数法或者其他格式
      for(let i = 0 ; i < dataList.length ; i++ ){
        for(const key in dataList[i]){
          if(key=='name'||key=='url')
            str+=`${dataList[i][key] + '\t'},`;
        }
        str+='\n';
      }
      console.log(str)
      // encodeURIComponent解决中文乱码
      const uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str);
      // 通过创建a标签实现
      const link = document.createElement("a");
      link.href = uri;
      // 对下载的文件命名
      link.download =  "服务链接表.csv";
      link.click();
      this.$message.success('导出成功')


    },
    goHomeList(){
      this.XTBZ_FullScreen=false
      this.XTBZ_Stey=1
    },
    clearAll() {
        this.$store.state.search.longitude = ''
        this.$store.state.search.latitude = ''
        this.$store.state.search.selectedRangeStore = {
            upload:'',
            china:'',
            world:'',
            point:'',
            draw:'',
            coordinatesArray:'',
            rectangle:'',
            circle:''
        }
    },
    checkAndShow(shape_id) {
      console.log(shape_id)
      let shape
      this.overlay=true
  
      let param=new FormData();
      param.append('id',shape_id)
      this.axios.post("/map_service_back/vectorLibrary/getVectorDetail", param)
        .then((response) => {
          shape = response.data.data.geojson

          this.clearAll()
          this.overviewGeo.geojson=JSON.parse(shape)
          this.overviewGeo.id=shape_id
          if (this.overviewGeo.geojson.coordinates.length > 10) {
            this.viewVectorModal = true;
            this.overlay=false

            this.$nextTick(() => {
                this.$refs.map.mapObject.fitBounds(L.geoJSON(this.overviewGeo.geojson).getBounds())
            })
            this.$message.error('暂不支持选择要素数量大于10的矢量创建项目');
            return
          }
          
          let param1=new FormData();
          // param.append('shape_id',shape_id);
          param1.append('geom',shape);
          this.axios
            .post("/map_service_back/program/geomAreaHandle", param1, {
              headers: {
                Authorization: "Bearer " + this.getKey(),
              },
            }).then(res => {
              this.overlay=false

              if (res.data.needToBuffer) {
                this.bufferGeo.geojson=JSON.parse(res.data.data.geojson)
                this.bufferGeo.area=res.data.data.area
              } else {
                this.bufferGeo.geojson=''
                this.bufferGeo.area=''
              }
              this.viewVectorModal = true;
              this.$nextTick(() => {
                  this.$refs.map.mapObject.fitBounds(L.geoJSON(this.overviewGeo.geojson).getBounds())
              })
            })
        })
      
    },
    handleCheckboxChange:function(data){
      console.log(this.editTree)
      console.log('套件选择')
      this.editTree=data
      let treeData=data.treeData;
      console.log(treeData)
      let repositoryObj=[];
      this.addProjectData.repository={list:[]};
      //把选中的tk、mk以接口要求格式赋值给repositoryObj
      for(let i=0;i<treeData.length;i++){
        if(treeData[i].$checked||treeData[i].$indeterminate){
          console.log("》》》》》in if 1")
          if(treeData[i].mkList){
            let temp_mkList=treeData[i].mkList
            let mkList=[];
            for(let j=0;j<temp_mkList.length;j++){
              if(temp_mkList[j].$checked){
                mkList.push((temp_mkList[j].id).split("_")[0])
              }
            }
            repositoryObj.push({"id":treeData[i].id,"mk_ids":mkList})
          }
        }
      }
      console.log("检验MK")
      console.log(repositoryObj)
      if(repositoryObj.length>0){
        this.addProjectData.repository={"list":repositoryObj}
      }
      console.log("this.addProjectData")
      this.print(this.addProjectData.repository)
    this.print(this.addProjectData)
    },
    //确认编辑项目
    clickConfirmEditProject:function () {
      console.log('确认编辑项目')
      this.editProjectData.start_time=this.tempTime_edit[0];
      this.editProjectData.end_time=this.tempTime_edit[1];
      let param=this.editProjectData;
      if(!param.name){
        this.$message.error('请输入项目名')
        return;
      }
      else if(!param.start_time||!param.end_time){
        this.$message.error('请输入起止时间')
        return;
      }
      let that = this;
      let paramForm = new FormData();
      paramForm.append('program_id', param.program_id);
      paramForm.append('name', param.name);
      paramForm.append('start_time', param.start_time);
      paramForm.append('end_time', param.end_time);
      paramForm.append('description', param.description);
      paramForm.append('shape_ids', param.shape_ids);
      paramForm.append('group_id', param.group_id);
      paramForm.append('repository', JSON.stringify(param.repository));
      paramForm.append('geojson', param.geojson);
      this.axios
          .post("/map_service_back/program/editProgram", paramForm, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('编辑项目')
        console.log(response)
        if (response.data.code == 200) {
          this.$message.success(response.data.message)
          that.addProjectData = {
            name: '',
            start_time: '',
            end_time: '',
            description: '',
            shape_ids: '',//矢量库选择的矢量
            group_id: '',
            repository: '',//套件与选择的图层
            geojson: '',//上传矢量或勾画矢量
          }
          this.editProjectModal = false;
          this.getMyProjectList();
        } else {
          this.$message.error(response.data.message);
          this.confirmCreateProjectModal = false;
        }

      })
    },
    clickCreateProject: function () {
      console.log('点击创建`项目')
      this.addProjectData.start_time=this.tempTime[0];
      this.addProjectData.end_time=this.tempTime[1];
      this.print(this.addProjectData);
      let param=this.addProjectData;
      console.log("this.addProjectData")
      console.log(this.addProjectData)
      if(!param.name){
        this.$message.error('请输入项目名')
        return;
      }
      else if(!param.start_time||!param.end_time){
        this.$message.error('请输入起止时间')
        return;
      }
      else if(param.repository.list.length==0){
        this.$message.error('请选择套件')
        return;
      }
      else if(param.shape_ids.length<1&&!param.geojson){
        this.$message.error('请选择矢量')
        return;
      }
      this.showVectoryCheckLoading=true;
      let reposityIds=[]
      for(let i=0;i<param.repository.list.length;i++){
        reposityIds.push(param.repository.list[i].id)
      }
      let param_form=new FormData();
      param_form.append('repository',JSON.stringify(this.addProjectData.repository));
      param_form.append('shape_ids',param.shape_ids.join(','));
      console.log('param_form')
      this.axios
          .post("/map_service_back/program/checkShpUseInReps", param_form,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
          if(response.data.hasNotIntersect){
            console.log('无相交')
            console.log(response.data.data)
            this.noIntersectResponse=response.data.data;
            this.noIntersectModal=true;
            this.showVectoryCheckLoading=false;
          }else {
            console.log('查看套件使用情况')
            this.repositoryRemainlist=response.data.data;
            console.log(this.repositoryRemainlist);
            let remainList=this.repositoryRemainlist;
            this.showVectoryCheckLoading=false;
            for(let i=0;i<remainList.length;i++){
              if(remainList[i].preArea>100000&&remainList[i].repository_name!="体验版"){
                this.$message.error('套件：'+remainList[i].repository_name+'的使用面积已超过10万平方公里,无法继续使用，请重新选择套件。')
                return;
              }
            }
            this.$message.success('通过套件剩余量检查，可继续使用')
            //NOTE 校验矢量面积，自动扩充
            let formdata = new FormData();
            // let shapes = { list: [{ id: "xxx", shape: "xxx" ,"area": "xxx" ,name:"xxx",create_time:"xxx" }] }
            let shapes = { list: [] }

            for (let i = 0; i < this.vectorList.length; i++) {
              const vector = this.vectorList[i];
              for (let j = 0; j < param.shape_ids.length; j++) {
                const shape_id = param.shape_ids[j];
                if (vector.id==shape_id) {
                  shapes.list.push({ id: vector.id, shape: vector.shape, area: vector.area,name:vector.name,create_time:vector.create_time })
                }
              }
            }

            formdata.append('shapes', JSON.stringify(shapes));
            this.axios.post("/map_service_back/program/checkGeomArea", formdata,{
              headers: {
                Authorization: "Bearer " + this.getKey(),
              },
            }).then(res => {
              if (res.data.code==200) {
                this.vectorBufferedList = res.data.data
              }
              this.confirmCreateProjectModal = true;
              this.showVectoryCheckLoading=false;
            })
          }

})
    },
    confirmCreateProject: function () {
      let shapes = { list: [] }
      this.vectorBufferedList.forEach(v => {
        if (v.new_area) {
          shapes.list.push({ id: v.shape_id, shape: v.buffered_geom, area: v.new_area,name:v.shape_name,create_time:v.create_time })
        } else {
          shapes.list.push({ id: v.shape_id, shape: v.old_geom, area: v.old_area,name:v.shape_name,create_time:v.create_time })
        }
      })

      let data = this.addProjectData;
      let that = this;
      let param = new FormData();
      param.append('name', data.name);
      param.append('start_time', data.start_time);
      param.append('end_time', data.end_time);
      param.append('description', data.description);
      param.append('shapes', JSON.stringify(shapes));
      // param.append('shape_ids', data.shape_ids);
      param.append('group_id', data.group_id);
      // param.append('repository',data.repository);
      param.append('repository', JSON.stringify(data.repository));
      param.append('geojson', data.geojson);
      this.axios
          .post("/map_service_back/program/insertProgram", param, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('创建项目')
        console.log(response)
        if (response.data.code == 200) {
          this.$message.success(response.data.message)
          that.addProjectData = {
            name: '',
            start_time: '',
            end_time: '',
            description: '',
            shape_ids: '',//矢量库选择的矢量
            group_id: '',
            repository: {list:[]},//套件与选择的图层
            geojson: '',//上传矢量或勾画矢量
          }
          this.tempTime[0]="";
          this.tempTime[1]="";
          this.confirmCreateProjectModal = false;
          this.createProjectModal = false;
          this.getMyProjectList();
        } else {
          this.$message.error(response.data.message);
          this.confirmCreateProjectModal = false;
        }

      })

    },
    getKey() {
      return localStorage.getItem("token");
    },
    clickProject: function (projectId, item) {
      console.log(item)
      if (item) {
        this.currentProject=item;
        this.groupId_currentProject = item.group_id;
        this.getMembersList();
        this.wyhc_name=""
        this.wyhc_ipagination={
          current: 1,
              pageSize: 10,
              // pageSizeOptions: ['10', '20', '30'],
              showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
              showQuickJumper: true,
              // showSizeChanger: true,
              total: 0
        }
        this.wyhc_createModal=false
        this.wyhc_createData={
              name:'',
              desp:"",
              jl1UserId:'',
              programId:'',
              importShapeFile:''
        }
        this.getList_wyhc();//获取外业核查列表
        if (item.delete_status == 0) {
          this.exhibitLevel = 2;
          this.projectId = projectId
          this.frameUrlOld = this.frameBaseUrl + `/analysisTask/SampleLabelAudit?token=${this.getKey()}&projectId=${this.projectId}`
          this.axios({
            method: 'get',
            url: '/tiles_back/markTask/queryManagerMarkTask',
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
            params: {
              projectId: projectId,
              pageNo: this.ipagination.current,
              pageSize: 10,
              taskName: this.InputTaskName,
              taskStatus: this.InputTaskStatus,
            }
          }).then((response) => {
            if (response.data.code == 200) {
              this.dataSource = response.data.data.records
            } else {
              this.$message.warning('操作失败！')
            }
          })
        } else {
          this.$message.error('项目已关闭')
        }
      } else {
        this.exhibitLevel = 2;
        this.projectId = projectId
        this.axios({
          method: 'get',
          url: '/tiles_back/markTask/queryManagerMarkTask',
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
          params: {
            projectId: projectId,
            pageNo: this.ipagination.current,
            pageSize: 10,
            taskName: this.InputTaskName,
            taskStatus: this.InputTaskStatus,
          }
        }).then((response) => {
          if (response.data.code == 200) {
            this.dataSource = response.data.data.records
          } else {
            this.$message.warning('操作失败！')
          }

        })
      }


    },
    getSignUpData: function () {
      let that = this
      this.axios
          .get("/loginapi/course/register/queryCourseRegisterList", {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('用户信息')
        console.log(response)
        if (response.status == 200) {
          that.dataList = response.data.data
        }
      })
    },
    //点击分享链接
    clickShareProject: function (data) {
      console.log(data)
      let param = new FormData();
      param.append('program_id', data.id);
      param.append('pageNum', 1);
      param.append('pageSize', 1000);
      this.axios
          .post("/map_service_back/program/getTileUrls", param, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('分享项目')
        console.log(response)
        this.shareList = response.data.data;
      })
      this.shareLinkModal = true;
    },
    //点击关闭切片服务
    clickCloseProject: function (item) {
      if (item.delete_status == 0) {
        this.closeProjectModal = true;
        this.closeProjectId = item.id;
        this.closeProjectName=item.name;
      } else {
        this.$message.error("此项目已经处于关闭状态")
      }

    },
    //点击编辑项目
    clickEditProject: function (data) {
      this.editProjectData.program_id=data.id;
      this.editProjectData.name=data.name;
      this.editProjectData.description=data.description;
      this.editProjectData.group_id=data.group_id;
      this.tempTime_edit[0]=data.start_time;
      this.tempTime_edit[1]=data.end_time;
      this.editProjectData.shape_ids=data.shape_ids;
      this.editProjectData.repository=data.repository;
      this.editProjectData.geojson=data.geojson;
      this.editProjectData.shapes=data.shapes;//回显矢量
      this.editProjectData.edit_repository=data.repository_show.list;//回显套件
      this.editProjectModal = true;
    },
    //确认关闭项目
    confirmCloseProject: function () {
      let param = new FormData();
      param.append('program_id', this.closeProjectId);
      this.axios
          .post("/map_service_back/program/closeProgram", param, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('关闭项目')
        console.log(response)
        if (response.data.code == 200) {
          this.$message.success(response.data.message);
          this.closeProjectModal = false;
          this.getMyProjectList();
        } else {
          this.$message.error(response.data.message);
        }
      })
    },
    disabledDate(current) {
      console.log("时间日期选择器")
      console.log(current)
      // Can not select days before today and today
      return current && current < moment().subtract(1, 'day').endOf('day');
    },
    //以下为任务函数
    selectTypeChange: function () {
      this.InputTaskStatus = ''
      this.InputTaskName = ''
      this.ipagination.current = 1
      if (this.selectType == 1) {
        this.clickProject(this.projectId)
      } else if (this.selectType == 2) {
        console.log('2')
      }
      this.XTBZ_Stey = 1;
    },
    //显示我的任务，任务详情（协同标注）
    showProjectDetail: function (data) {
      console.log(data)
      this.projectDetailDialog = true;
    },
    //查看任务
    intoProject: function (data) {
      console.log(data);
      this.XTBZ_Stey = 2;
    },
    //获取我的项目
    getMyProjectList: function () {
      let that = this
      let param = new FormData();
      param.append('pageNum', 1);
      param.append('pageSize', 1000);

      this.axios
          .post("/map_service_back/program/getProgramList", param, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('获取我的项目列表')
        console.log(response)
        if (response.data.data) {
          this.projectList = response.data.data;
        } else {
          this.projectList = []
        }
        console.log(1)
        console.log(this.projectList)

      })
    },
    //以下为:新建项目功能需要
    //获取矢量库
    getVectorLibrary: function () {
      let that = this
      let param = new FormData();
      param.append('pageNum', 1);
      param.append('pageSize', 1000);

      this.axios
          .post("/map_service_back/vectorLibrary/getVectorLibrary", param, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('获取我的矢量库列表')

        if (response.data) {
          this.vectorList = response.data.data;
        }
        console.log(this.vectorList)
      })
    },
    //查询团队列表（仅获取用户自己创建的）
    getTeamList: function () {
      this.axios.post("/tilesapi/tiles/group/queryUserCreateGroupList", null, {
        headers: {
          Authorization: 'Bearer ' + this.getKey(),
        }
      }).then((response) => {
        this.teamList = response.data.data;
        console.log("获取团队列表")
        console.log(this.teamList)
      })
    },
    //获取我的套件库
    queryRepositoryTkList: function () {
      this.axios.post("/tilesapi/tiles/repository/queryUserRepositoryList", null, {
        headers: {
          Authorization: 'Bearer ' + this.getKey(),
        }
      }).then((response) => {
        console.log("获取套件列表")
        console.log(response)
        let tempArray=response.data.data;
        console.log("套件二维数组")
        console.log(tempArray)
        for(let i=0;i<tempArray.length;i++){
          for(let j=0;j<tempArray[i].mkList.length;j++){
            tempArray[i].mkList[j].id=tempArray[i].mkList[j].id+"_"+i;
          }
        }

        this.multipleTreeData = tempArray;

      })
    },

    search() {
      this.clickProject(this.projectId)
    },
    reSet() {
      this.InputTaskName = ''
      this.InputTaskStatus = ''
      this.ipagination.current = 1
      this.clickProject(this.projectId)


    },


    //增加任务
    handleAdd() {
      this.$router.push("/createProject")
      // this.$refs.modalForm.add(this.projectId);
      // this.$refs.modalForm.title = '新建协同标注'
    },
    handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.clickProject(this.projectId);
    },
    //编辑影像标注任务
    handleEdit(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = "编辑";
      this.$refs.modalForm.disableSubmit = false;
    },
    //详情按钮  弹窗
    handleTaskDetail(record) {
      let that = this;
      this.taskImages = []
      for (let i = 0; i < record.imageUrls.length; i++) {
        this.taskImages.push(record.imageUrls[i].imageName)
      }
      this.axios({
        method: 'get',
        url: '/tiles_back/markTask/queryMarkTaskUserById',
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
        params: {
          taskId: record.id,
        }
      }).then((res) => {
        if (res.data.code == 200) {
          this.taskUsers = [];
          if (res.data.data.records.length > 0) {
            for (let i = 0; i < res.data.data.records.length; i++) {
              let temp = res.data.data.records[i];
              this.taskUsers.push(temp.name);
            }
          }
        } else {
          this.$message.warning('操作失败！')
        }

      })
      this.axios({
        method: 'get',
        url: '/tiles_back/markTask/queryMarkTaskAuditorById',
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
        params: {
          taskId: record.id,
        }
      }).then((res) => {
        if (res.data.code == 200) {
          this.aduitUsers = [];
          if (res.data.data.records.length > 0) {
            for (let i = 0; i < res.data.data.records.length; i++) {
              let temp = res.data.data.records[i];
              this.aduitUsers.push(temp.name);
            }
          }
        } else {
          this.$message.warning('操作失败！')
        }

                      
            })
            this.model = Object.assign({}, record);
            this.visible = true;
          },
          //close
          handleCancel(){
            this.visible = false;
          },
          //点击查看按钮，跳转到标注审核详情页面
          handleDetail(record){
            console.log(record);
            this.frameUrl = this.frameBaseUrl + `/analysisTask/SampleLabelAudit?taskId=${record.id}&token=${this.getKey()}&projectId=${this.projectId}&project=1`
            this.XTBZ_Stey=2;
            this.XTBZ_FullScreen = true
          },
          //点击开始按钮，更改任务状态，各标注人员可查询到该任务进行标注操作
          handleStart(record){
            //首先查询该任务是否含有标注人员
            let that = this;
            this.axios({
                        method: 'get',
                        url: '/tiles_back/markTask/queryMarkTaskUserById',
                        headers: {
                          Authorization: "Bearer " + this.getKey(),
                        },
                        params: {
                          taskId: record.id
                        }
                    }).then((response) => {
                  if(response.data.data.records.length>0){
                    this.axios({
                        method: 'get',
                        url: '/tiles_back/markTask/queryMarkTaskAuditorById',
                        headers: {
                          Authorization: "Bearer " + this.getKey(),
                        },
                        params: {
                          taskId: record.id
                        }
                    }).then((res) => {
                      if(res.data.data.records.length>0){
                        let formData = new FormData();
                        formData.append('taskId', record.id);
                        this.axios
                            .post("/tiles_back/markTask/startMartTask", formData,{
                              headers: {
                                Authorization: "Bearer " + this.getKey(),
                              },
                            }).then((response) => {
                              if(response.data.code == 200){
                                that.$message.success('操作成功！')
                                that.clickProject(this.projectId);
                              }else{
                                that.$message.warning('操作失败！')
                              }
                              
                            })
                          
                        }else{
                    this.$message.warning('请至少选择一名审核人员');
                  }
                    })


        } else {
          this.$message.warning('请至少选择一名标注人员');
        }
      })
    },
    //删除标注任务
    handleDelete(record) {
      let that = this;
      this.axios({
        method: 'delete',
        url: '/tiles_back/markTask/deleteMarkTaskById',
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
        params: {
          'taskId': record.id,
          'geometryType': record.geometryType
        }
      }).then((response) => {
        if (response.data.code == 200) {
          this.$message.success('操作成功！');
          this.clickProject(this.projectId);
        } else {
          this.$message.warning('操作失败！');
        }
      })
    },
    //点击标注人员按钮
    handleMarker(record) {
      console.log(record)
      this.$refs.markerModalForm.show(record.id, record.taskStatus, record.imageUrls, this.groupId_currentProject);
    },
    //点击审核人员按钮
    handleShenhe(record) {
      console.log(record)
      this.$refs.shenheModalForm.show(record.id, record.taskStatus, record.imageUrls, this.groupId_currentProject);
    },
    //点击结束任务按钮
    handleTaskOver(record) {
      let formData = new FormData();
      formData.append('taskId', record.id);
      this.axios
          .post("/tiles_back/markTask/finishMarkTask", formData, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        if (response.data.code == 200) {
          this.clickProject(this.projectId)
          this.$message.success('操作成功!');
        } else {
          this.$message.warning('操作失败!');
        }
      })
    },
  },
  mounted() {
    this.getMyProjectList();
    this.getVectorLibrary();
    this.getTeamList();
    this.queryRepositoryTkList();
    let array = [
      {
        id: '01',
        name: '广东省',
        children: [
          {
            fullPath: '0101',
            name: '广州市',
          },
          {
            fullPath: '0102',
            name: '深圳市',
          },
        ],
      }]
    this.repositoryMultipleTreeData = [array]


    bus.$off('update')
    bus.$on('update', (projectId) => {
      this.clickProject(projectId)

    })


    this.frameUrlOld = this.frameBaseUrl + `/analysisTask/SampleLabelAudit?token=${this.getKey()}&projectId=${this.projectId}`
  }
}
</script>

<style scoped lang="scss">
::v-deep .ant-select-arrow .ant-select-arrow-icon {
  display: none;
}
.vectorPanel_1 {
  width: 100%;
  min-height: 200px;
  height:auto;
  .itemCtn {
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    border-bottom: 1px solid #D8D8D8;;
  }

}
.vectorPanel {
  width: 100%;
  height: 200px;
  //border: solid 1px #f56300;
  overflow-y: scroll;

  .itemCtn {
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    border-bottom: 1px solid #D8D8D8;;
  }
}

/*滚动条样式*/
.vectorPanel::-webkit-scrollbar {
  width: 4px;
}

.vectorPanel::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.vectorPanel::-webkit-scrollbar-track {
}

.myTask {
  .detailCtn {
    .table1 {
      width: 667px;

      .tr1 {
        height: 40px;
        line-height: 40px;
        width: 100%;
      }

      .td1 {
        width: 200px;
      }

      .blod {
        font-weight: bold;
      }
    }
  }

  ::v-deep .ant-table-thead > tr > th {
    font-weight: 700;
  }

  .tableCtn {
    width: 100%;
    height: 500px;
    padding-right: 20px;
  }

  .searchPanel {
    width: 100%;
    height: 60px;
    position: relative;
    display: flex;
    justify-content: left;
    padding-top: 10px;

    .txt {
      width: 85px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
    }

    .input {
      width: 200px;
      height: 40px;
      line-height: 40px;
    }
  }

  .bash_iframe {
    width: calc(100% - 20px);
  }

  .signUp_content {
    width: 100%;
    height: 100%;
    overflow-y: auto;

    .componentCtn-main {
      position: relative;
      width: 100%;
      height: auto;
      min-height: 570px;
      display: flex;
      justify-content: left;
      flex-flow: wrap;
    }

    .componentCtn-main-fullScreen {
      position: fixed;
      top: 0px;
      left: 0px;
      width: 100vw;
      height: 100%;
      z-index: 10000;
    }
  }

  /*滚动条样式*/
  .signUp_content::-webkit-scrollbar {
    width: 4px;
  }

  .signUp_content::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .signUp_content::-webkit-scrollbar-track {
  }

  .selectPanel {
    height: 30px;
    line-height: 30px;
    width: 100%;
    position: relative;
  }

  .top {
    height: 84px;
    line-height: 84px;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
  }

  .componentsCtn_1 {
    width: 100%;
    min-height: 660px;
    height: auto;
    background: #F5F5F6;
    border-radius: 16px;
    padding-left: 35px;
  }
}

::v-deep .ant-calendar-range-picker-input {
  text-align: left;
}

::v-deep .ant-input-lg {
  font-size: 14px;
}

.createProjectLine {
  display: flex;
  justify-content: left;
  width: 100%;
  height: auto;
  min-height: 40px;
  margin-bottom: 20px;

  .item-name {
    position: relative;
    width: 90px;
    height: 40px;
    text-align: left;
    line-height: 40px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
  }

  .item-input {
    width: 560px;
    min-height: 40px;
    height: auto;
    .edit-tj-ctn{
      width: 100%;
      min-height: 100px;
      height:auto;
      border-radius: 8px;
      border: solid 1px #d7d7d7;
      .item-ctn{
        width:100%;
        height:auto;
        padding:0px 10px 5px 10px;
        .tj-title{
          height:35px;
          line-height: 35px;
          font-size: 16px;
          width: auto;
        }
        .mk-ctn{
          width: 100%;
          min-height: 30px;
          line-height: 30px;
          border:dashed 1px #d0d0d0;
          padding: 3px;
          display: flex;
          justify-content: left;
          flex-wrap:wrap;
          .mk-item{
            height:24px;
            line-height: 24px;
            text-align: center;
            padding-left:3px;
            padding-right:3px;
            border-radius: 5px;
            border:solid 1px #75adee;
            font-size: 14px;
            min-width: 40px;
            width:auto;
            margin-right: 10px;
            margin-bottom:5px;
            margin-top:5px;
          }
        }
      }
    }
  }
}

.lineClamp {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  font-size: 20px;
  //font-weight: 600;
}

.shareListCtn {
  width: 620px;
  height: auto;
  min-height: 60px;
  max-height: 420px;
  overflow-y: auto;
  font-size: 18px;
  padding-left: 20px;
  word-break: break-all;
}

.shareListCtn::-webkit-scrollbar {
  width: 4px;
}

.shareListCtn::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.shareListCtn::-webkit-scrollbar-track {
}

.projectCtn {
  width: 232px;
  height: 258px;
  border-radius: 16px;
  border: 1px solid #979797;
  margin-right: 32px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .topCtn {
    position: relative;
    margin-top: 6px;
    width: 220px;
    height: 189px;
    border-radius: 16px;
    border: 1px solid #979797;
    background-image: url("~@/assets/userCenter/我的项目背景图.png");
    background-repeat: no-repeat;
    cursor: pointer;

    .contentMask {
      display: none;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 16px;
      top: 0px;
      left: 0px;
      z-index:1000;

      .contentItem {
        width: 100%;
        height: 20px;
        line-height: 20px;
        padding-left: 15px;
        padding-right: 10px;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
  }
 ::v-deep.ant-btn-primary-disabled, .ant-btn-primary.disabled, .ant-btn-primary[disabled], .ant-btn-primary-disabled:hover, .ant-btn-primary.disabled:hover, .ant-btn-primary[disabled]:hover, .ant-btn-primary-disabled:focus, .ant-btn-primary.disabled:focus, .ant-btn-primary[disabled]:focus, .ant-btn-primary-disabled:active, .ant-btn-primary.disabled:active, .ant-btn-primary[disabled]:active, .ant-btn-primary-disabled.active, .ant-btn-primary.disabled.active, .ant-btn-primary[disabled].active {
   color: rgba(0, 0, 0, 1);
 }
  .topCtn:hover .contentMask {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: rgba(0, 0, 0, 0.6);
  }

  .middleCtn {
    width: 213px;
    height: 32px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1E81EB;
    line-height: 32px;
    text-align: center;
    background: linear-gradient(108deg, #1E81EB 0%, #AE48FF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .bottomCtn {
    width: 100%;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;

    .bottomImg {
      display: block;
      margin-right: 16px;
      cursor: pointer;
    }
  }
}

.signUp_item_banner {
  width: 1032px;
  height: 122px;
  background: #F7F7F7;
  border-radius: 16px;
  margin-bottom: 20px;
  padding-top: 31px;
  padding-left: 39px;
}

.signUp_content {
  width: 100%;
  height: 576px;
  overflow-y: auto;

  .componentCtn-main {
    width: 100%;
    height: auto;
    min-height: 570px;
    display: flex;
    justify-content: left;
    flex-flow: wrap;
  }
}

/*滚动条样式*/
.signUp_content::-webkit-scrollbar {
  width: 4px;
}

.signUp_content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.signUp_content::-webkit-scrollbar-track {
}

.top {
  height: 84px;
  line-height: 84px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
}

.componentsCtn_1 {
  width: 100%;
  min-height: 660px;
  height: auto;
  background: #F5F5F6;
  border-radius: 16px;
  padding-left: 35px;
}

    .overviewVectorDiv{
      width: 660px;
      height: 570px;
      margin-left: -24px;
      margin-top: -24px;
      margin-bottom: -24px;
      // border:solid 1px #FF0000;
    }
    ::v-deep .ant-modal-close{
      z-index: 410;
    }




    ::v-deep .mapDialog{
        overflow-y: unset;
        z-index: 1001;
    }
    ::v-deep .theme--light.v-card{
        background: rgba(238,238,238);
    }
    
    .mapdiv{
        position: absolute;
        width: calc(100% - 10px);
        height: calc(100% - 10px);
        left: 5px;
        top: 5px;
    }
    ::v-deep .v-dialog:not(.v-dialog--fullscreen){
        max-height: unset;
    }
    ::v-deep .v-dialog__content,
    ::v-deep.v-dialog__content--active{
        z-index: 1001 !important;
    }
    // ::v-deep .ant-select-selection{
    //     background: #2e3338;
    //     color: white;
    // }
    // ::v-deep .ant-select-arrow{
    //     color: white;
    // }
</style>